import { render, staticRenderFns } from "./recommendHouse_company.vue?vue&type=template&id=44b09826&scoped=true"
import script from "./recommendHouse_company.vue?vue&type=script&lang=js"
export * from "./recommendHouse_company.vue?vue&type=script&lang=js"
import style0 from "./recommendHouse_company.vue?vue&type=style&index=0&id=44b09826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b09826",
  null
  
)

export default component.exports